import React from 'react';
import { Hero } from './Hero';
import { Capabilities } from './Capabilities';
import { CTA } from './CTA';
export function MobileApps() {
  return <div className="min-h-screen w-full bg-white" data-id="element-565">
      <Hero data-id="element-566" />
      <Capabilities data-id="element-567" />
      <CTA data-id="element-568" />
    </div>;
}